<template>
  <div>
    <label v-if="label">{{label}}</label>
    <input type="text" class="text-right" :value="value" :readonly="readonly" @input="input" @change="input" :name="name" @blur="blur" />
  </div>

</template>

<script>
import defaultTools from '../../mixins/defaultTools'
export default {
  name: 'CurrencyInput',
  mixins: [defaultTools],
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number],
      require: true,
      default: ''
    },
    name: {
      type: String,
      require: true,
      default: ''
    },
    label: {
      type: String,
      default: null
    },
    prop: {
      type: String,
      require: true,
      default: ''
    },
    scale: {
      type: Number,
      default: 2
    },
  },
  mounted() {
    if (this.value){
      this.setFormat()
    }
  },
  watch: {
    value: {
      handler(){
        if (this.readonly){
          this.setFormat()
        }
      }
    }
  },
  data(){
    return {
      changed: false
    }
  },
  methods: {
    setFormat() {
      this.$emit('input', this.formatNumber(this.input2Float(this.value), this.scale))
    },
    input(event) {
      this.changed = true
      this.$emit('input', event.target.value)
    },
    blur(event) {
      this.setFormat()
      this.$emit('blur', this.formatNumber(event.target.value, this.scale))
    }
  }
}

</script>

<style scoped>

</style>
